<template>
  <adivare-input
    @validation-request="validateField"
    :outer-class="outerClass"
    :legend-class="legendClass"
    :input-class="inputClass"
    :show-property="true"
    :label-class="labelClass"
    :property-name="propertyName"
    :placeholder="fieldLabel"
    :autocomplete="autocomplete"
    :form-type="formType"
    :field-label="fieldLabel"
    :optional="optional"
    :rows="rows"
  />
</template>

<script>
import formMixin from "../../../mixins/form-mixin";
import defaultFormValidatorMixin from "../../../mixins/default-form-validator-mixin";

export default {
  name: "adivare-default-form-element",
  mixins: [
    formMixin,
    defaultFormValidatorMixin,
  ],
  props: {
    formType: {
      required: true,
    },
  }
}
</script>
